@if (externalLoginProvider == externalLoginProviderEnum.SFC) {
  <p-dialog [header]="'extLogin.sfc.header'|translate" [modal]="true" [(visible)]="visible" [style]="{ width: '25rem' }" closable="false" draggable="false" resizable="false">
        <p>{{'extLogin.sfc.text'|translate}}</p>
        <hr>
        <p [innerHTML]="'extLogin.sfc.becomeMember'|translate"></p>
            
        <div class="d-flex mt-5 justify-content-between">
            <p-button severity="secondary" (click)="cancel()">{{'av.cancel'|translate}}</p-button>
            <p-button (click)="proceedToLogin()">{{'av.login'|translate}}</p-button>
        </div>
    </p-dialog>
}
